// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ulFF","productName":"Table_productName__3RTU1"};